<template>
  <div class="wrapper">
    <div class="login-frame">
      <div class="login-form">
        <p class="login-title">注册新机构</p>
        <el-form
          :rules="registerRules"
          ref="registerForm"
          :model="registerInfo"
          :show-message="false"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="account">
                <el-input
                  placeholder="管理员登录账户"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.account"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="name">
                <el-input
                  placeholder="姓名"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.name"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="password">
                <el-input
                  placeholder="密码"
                  prefix-icon="iconfont icon-yuechi"
                  v-model="registerInfo.password"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="repassword">
                <el-input
                  placeholder="再次输入密码"
                  prefix-icon="iconfont icon-yuechi"
                  v-model="registerInfo.repassword"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="email">
                <el-input
                  placeholder="邮箱"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.email"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="rootOrganizationName">
                <el-input
                  placeholder="机构名称"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.rootOrganizationName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- @keyup.enter.native="sendValidationCode" -->
            <el-col :span="12">
              <el-form-item prop="cellphone">
                <el-input
                  placeholder="手机号"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.cellphone"
                >
                  <el-button
                    slot="append"
                    class="sendValidationCode-btn"
                    v-if="sendValidationCodeCountDown === 0"
                    @click.native.prevent="sendValidationCode()"
                    >发送验证码</el-button
                  >
                  <el-button
                    slot="append"
                    v-if="sendValidationCodeCountDown > 0"
                    >已发送（{{ sendValidationCodeCountDown }}）</el-button
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="validationCode">
                <el-input
                  placeholder="验证码"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="registerInfo.validationCode"
                >
                  <!-- @keyup.enter.native="handleRegister" -->
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form>
          <el-row :gutter="20">
            <el-col :span="12">
              <span style="font-size: 13px">
                请仔细填写您的联系信息，否则可能无法找回密码。<br />
                如果您要加入一个已有的组织机构，请联系其管理员为您添加用户，而非自行注册新账户。
              </span>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-button
                  type="primary"
                  class="login-btn"
                  @click.native.prevent="handleRegister()"
                  >注 册</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  class="register-btn"
                  @click.native.prevent="handleToLogin"
                  plain
                  >返回登录</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- <div class="copy-right"></div> -->
  </div>
</template>

<script>
import { hex_md5 } from "@/utils/MD5";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码；"));
      } else {
        if (this.registerInfo.repassword !== "") {
          this.$refs.registerForm.validateField("repassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码；"));
      } else if (value !== this.registerInfo.password) {
        callback(new Error("两次输入密码不一致；"));
      } 
      else if(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/g) == null) //强密码验证
      {
        //https://c.runoob.com/front-end/854/
        //强密码(必须包含大小写字母和数字的组合，可以使用特殊字符，长度在6-30之间)
        //^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,30}$

        callback(new Error("密码必须 8 位以上，至少包含大小写字母和数字；"));
      }
      else {
        callback();
      }
    };

    return {
      registerInfo: {
        account: "",
        name: "",
        password: "",
        repassword: "",
        cellphone: "",
        validationCode: "",
        rootOrganizationName: "",
        email: "",
      },
      tempPassword: null,
      sendValidationCodeCountDown: 0,
      validationCodeInterval: 0,
      registerRules: {
        account: [
          { required: true, message: "请输入登录账户；", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入姓名；", trigger: "change" }],
        password: [{ validator: validatePass, trigger: "change" }],
        repassword: [{ validator: validatePass2, trigger: "change" }],
        email: [{ required: true, message: "请输入邮箱；", trigger: "change" }],
        cellphone: [
          {
            required: true,
            message: "请输入手机号；",
            trigger: "change",
          },
        ],
        validationCode: [
          {
            required: true,
            message: "请输入验证码；",
            trigger: "change",
          },
        ],
        rootOrganizationName: [
          {
            required: true,
            message: "请输入组织机构名称；",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.validationCodeInterval = setInterval(() => {
      this.sendValidationCodeCountDown > 0
        ? (this.sendValidationCodeCountDown -= 1)
        : "";
    }, 1000);
  },
  destroyed() {
    clearInterval(this.validationCodeInterval);
  },
  methods: {
    handleRegister() {
      this.$refs.registerForm.validate((valid, data) => {
        if (valid == false) {
          this.$uiHelper.showValidationMessage(valid, data);
          return;
        }

        

        //在注册之前，要把明文密码暂存下来
        //如果注册不成功，比如账户被占用，用户再点注册时，不能反复MD5
        if (this.tempPassword == null || this.tempPassword == "") {
          this.tempPassword = this.registerInfo.password;
        }

        this.registerInfo.password = hex_md5(this.tempPassword).toUpperCase();
        this.registerInfo.repassword = hex_md5(this.tempPassword).toUpperCase();

        this.$domainApi.createDomain(this.registerInfo).then((res) => {
          console.log(res);
          if (res.data.successful) {
            // this.$alert("注册成功", "提示");
            // this.$router.push({ path: "/login" });

            this.$alert("注册成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                // this.$router.push({ path: "/login" });

                let loginInfo = {
                  account: this.registerInfo.account,
                  password: this.registerInfo.password,
                };

                this.$userContextApi.login(loginInfo).then((res) => {
                  if (res.data.successful) {
                    // alert(JSON.stringify(res.data.data));

                    //保存登录信息
                    this.$userContext.setLoginResult(res.data.data);

                    //当前日期时间必须要放在能持久化存储的地方，如localStorage
                    //因为有可能用户不走登录页面访问，有可能短时间之前登录过
                    //session 还没失效，直接访问某个指定的页面，此时 token 还是有效的
                    //但是很多页面右上角要显示实时计时，所以实时时间，不能localStorage存储
                    //localStorage中最多只能存一下年月日期数据
                    this.$dateTimeHelperApi.getDateTime().then((res) => {
                      if (res.data.successful) {
                        this.$userContext.setDateTime(res.data.data);

                        this.$router.push({ path: "/weeklyReport/post" });
                      }
                    });
                  } else {
                    this.$alert(res.data.message, "提示");
                  }
                });
              },
            });
          } else {
            this.registerInfo.password = this.tempPassword;
            this.registerInfo.repassword = this.tempPassword;
            this.tempPassword = null;
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    sendValidationCode() {
      this.$refs.registerForm.validateField("cellphone", (valid) => {
        // console.log("valid:");
        // console.log(valid);

        if (!valid) {
          this.$domainApi
            .sendValidationCode({
              cellphoneNumber: this.registerInfo.cellphone,
            })
            .then((res) => {
              if (res.data.successful) {
                this.sendValidationCodeCountDown = 60;
                this.$alert("验证码已发送", "提示");
              } else {
                this.$alert(res.data.message, "提示");
              }
            });
        } else {
          this.$uiHelper.showValidationMessage_Text(valid);
          return;
        }
      });
    },
    handleToLogin() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100vh;
  background: url("../assets/login-bg.jpg"); //center no-repeat;
  background-size: 100%;
  //background-size: 100% 100%;
  .login-frame {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 800px;
    // margin: 0 50%;
    // height: 440px;
    margin-top: -250px;
    margin-left: -420px;
    .login-title {
      color: #36b5f8;
      font-size: 17px;
      margin-bottom: 22px;
    }
    .sendValidationCode-btn {
      color: #36b5f8;
      background-color: #fff;
      cursor: pointer;
      border-top-style: none;
      border-right-style: none;
      border-bottom-style: none;
      border-left-style: none;
      height: 37px;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 14px;
    }
    .login-btn {
      font-size: 16px;
      color: #fff;
      background-color: #36b5f8;
      border-top-style: none;
      border-right-style: none;
      border-bottom-style: none;
      border-left-style: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-top: 15px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .register-btn {
      font-size: 16px;
      color: #36b5f8;
      background-color: #fff;
      border-color: #36b5f8;
      padding-top: 8px;
      padding-bottom: 8px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .login-form {
      position: relative;
      height: 440px;
      padding: 30px;
      background-color: #fff;
      // border-radius: 5px;
      //   box-shadow: 0 0 5px 2px #ccc;
      z-index: 2;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/register.vue